export const OFFERING_PHASES = {
  brand_design: [
    { key: "foundation", num: "01", label: "Foundation", subtitle: "Brand strategy, visual direction alignment & market research" },
    { key: "strategic", num: "02", label: "Strategic Design", subtitle: "Brand identity, messaging framework & creative direction" },
    { key: "build", num: "03", label: "Build", subtitle: "Asset creation, design system build & brand guidelines" },
    { key: "launch", num: "04", label: "Launch + Optimize", subtitle: "Final delivery, brand application & handoff to library" },
  ],
  web_design: [
    { key: "foundation", num: "01", label: "Foundation", subtitle: "Site audit, content inventory & sitemap architecture" },
    { key: "strategic", num: "02", label: "Strategic Design", subtitle: "Wireframes, UX decisions & content strategy sign-off" },
    { key: "build", num: "03", label: "Development", subtitle: "Visual design, development, mobile optimization & QA" },
    { key: "launch", num: "04", label: "Launch + Optimize", subtitle: "Go-live, redirects, post-launch refinements & analytics" },
  ],
  product_design: [
    { key: "foundation", num: "01", label: "Foundation", subtitle: "Product audit, user research & problem framing" },
    { key: "strategic", num: "02", label: "Strategic Design", subtitle: "Flows, information architecture & experience direction" },
    { key: "build", num: "03", label: "Build", subtitle: "UI system, prototypes & production-ready screens" },
    { key: "launch", num: "04", label: "Launch + Optimize", subtitle: "Handoff, QA support & post-launch refinements" },
  ],
  operational_ecosystem: [
    { key: "foundation", num: "01", label: "Foundation", subtitle: "Initial meeting, present state audit & framework delivery." },
    { key: "strategic", num: "02", label: "Synthesis", subtitle: "Research, immersion & strategic development." },
    { key: "build", num: "03", label: "Build", subtitle: "Blueprint in motion, aligned at the midpoint & presented with care." },
    { key: "launch", num: "04", label: "Activate", subtitle: "Account transfer, system handoff & your ownership." },
  ],
};

/** Studio / outreach rail colors by offering (Brand · Web · Product · Ops). */
export const OFFERING_KEYS = [
  "brand_design",
  "web_design",
  "product_design",
  "operational_ecosystem",
];

export const OFFERING_LABEL_SHORT = {
  brand_design: "Brand",
  web_design: "Web",
  product_design: "Product",
  operational_ecosystem: "Ops",
};

export const OFFERING_LABEL = {
  brand_design: "Brand design",
  web_design: "Web design",
  product_design: "Product design",
  operational_ecosystem: "Operational ecosystem",
};

export const OFFERING_COLORS = {
  brand_design: "#001EFF",
  web_design: "#2E4060",
  product_design: "#E891C0",
  operational_ecosystem: "#5B7CFF",
};

// Legacy / transitional aliases (DB field is still named service_tier in this codebase)
const LEGACY_TO_OFFERING = {
  essentials: "brand_design",
  growth: "web_design",
  partnership: "operational_ecosystem",
  infrastructure: "operational_ecosystem",
};

export function canonicalOffering(raw) {
  if (!raw) return "web_design";
  return LEGACY_TO_OFFERING[raw] || raw;
}

export function offeringColor(raw) {
  const key = canonicalOffering(raw);
  return OFFERING_COLORS[key] || OFFERING_COLORS.web_design;
}

export function offeringShortLabel(raw) {
  const key = canonicalOffering(raw);
  return OFFERING_LABEL_SHORT[key] || "—";
}
